module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"checklists":"Checklists","allocation_e_offer":"Allocation / eOffer","allocation_eoffer":"Allocation / eOffer"},"fr":{"checklists":"Listes de contrôle","allocation_e_offer":"Attribution/eOffer","allocation_eoffer":"Allocation / EOffre"}}')
  delete Component.options._Ctor
}
